import { InformacionTablaMaestra, Tarea } from '@app/shared';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { DatosSincronizacion, TablaDatos, TramiteAsociar } from './../../models/formulario-dinamico.model';
import {
  ValoresEspecificos,
  FiltroTableMasterGeneral,
  EstructuraEspecifica,
  Valores
} from './../../models/tabla-maestra.model';
import { ActaAUCTIFF, ActaAUCTIFFCinco } from './../../models/radicacion.model';
import { Const } from './../../util/constants';

@Injectable()
export class RefactorDynamicFormDataService {
  typeDocumentary: any;
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta la informacion de las tablas de la forma
   *
   * @param {number} idTask
   * @returns {Observable<TablaDatos[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getDataTables(idTask: number): Observable<{ 'tabla_datos': TablaDatos[] }> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get<{ 'tabla_datos': TablaDatos[] }>(this.api.get('dynamicFormInstance', [idTask])).subscribe(
          tables => {
            obs.next(tables);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   * Consulta la informacion de una maestra en especifico
   *
   * @param {number} idMaster
   * @returns {Promise<InformacionTablaMaestra>}
   * @memberof CheckListDataService
   */
  getInformacionMasterTable(idMaster: number): Promise<InformacionTablaMaestra> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().
        get<InformacionTablaMaestra>(this.api.get('structureMasterTable', [idMaster])).subscribe(
          masterTable => {
            resolve(masterTable);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
            reject(err);
          }
        );
    });
  }





  /**
   * Realiza la consulta de las columnas specificas de una maestra
   *
   * @param {EstructuraEspecifica} structure
   * @param {FiltroTableMasterGeneral[]} [filterMaster]
   * @param {string} [idRecords]
   * @param {*} [filterSede]
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getColumnsSpecificMasterTable(
    structure: EstructuraEspecifica,
    filterMaster?: FiltroTableMasterGeneral[],
    idRecords?: string,
    filterSede?: any,
    offset?: any,
    limit?: any

  ): Promise<ValoresEspecificos[]> {
    const formData = {
      estructura: structure
    };

    if (filterMaster && filterMaster.length) {
      formData['condicion'] = filterMaster;
    }

    if (idRecords && idRecords.length) {
      formData['id_registro'] = idRecords;
    } else {
      if (offset != undefined && offset != null) {
        formData['offset'] = offset;
      }
      if (limit) {
        formData['limit'] = limit;
      }


    }

    if (filterSede) {
      formData['tarea_id'] = filterSede['tarea'];
      formData['columna'] = filterSede['columna'];
    }

    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'), formData).subscribe(
        specificValues => {
          resolve(specificValues);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Calcula la suma de una cantidad determinada en los dias habiles de la empresa
   *
   * @param {Date} date
   * @param {number} quantityDays
   * @returns {Promise<Date>}
   * @memberof RefactorDynamicFormDataService
   */
  getCalculateSumWorkingDays(
    date: Date,
    quantityDays: number
  ): Promise<Date> {
    const formData = {
      fecha: date,
      dias: quantityDays
    };

    return new Promise((resolve, reject) => {
      this.http.post<Date>(this.api.get('workingDays'), formData).subscribe(
        dateF => {
          resolve(dateF);
        },
        err => {
          resolve(null);
          reject(err);
        }
      );
    });
  }

  /**
   * Calcula la resta de una cantidad determinada en los dias habiles de la empresa
   *
   * @param {Date} date
   * @param {number} quantityDays
   * @returns {Promise<Date>}
   * @memberof RefactorDynamicFormDataService
   */
  getCalculateSubtractWorkingDays(
    date: Date,
    quantityDays: number
  ): Promise<Date> {
    const formData = {
      fecha: date,
      dias: quantityDays * -1
    };

    return new Promise((resolve, reject) => {
      this.http.post<Date>(this.api.get('workingDays'), formData).subscribe(
        dateF => {
          resolve(dateF);
        },
        err => {
          resolve(null);
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta un registro en especifico
   *
   * @param {number} idRecord
   * @returns {Promise<Valores>}
   * @memberof RefactorDynamicFormDataService
   */
  getInformationDynamicTableMaster(
    idRecord: number,
  ): Promise<Valores> {

    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<Valores>(this.api.get('masterTableInformation', [idRecord]))
        .subscribe(
          valor => {
            resolve(valor);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              let message = '';
              if (typeof err.error === 'object') {
                for (const key in err.error) {
                  if (key) {
                    message += key + ': ' + err.error[key];
                  }
                }
              }
              if (message) {
                this.toastr.error(message, 'Error de operación');
              } else {
                this.toastr.error('Ha ocurrido un error inesperado.', 'Error de operación');
              }
            }
            reject(err);
          }
        );
    });
  }

  /**
   * Sincroniza los formulario y tablas con las otras tareas
   *
   * @param {DatosSincronizacion} dataSync
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormDataService
   */
  syncFormTask(dataSync: DatosSincronizacion): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .post<boolean>(this.api.get('synchronizationForms'), dataSync).subscribe(
          resp => {
            resolve(true);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta de los radicados a listar en el seletor de tipo radicados del sistema
   *
   * @param {number[]} clasifications
   * @returns {Promise<TramiteAsociar[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getDocumentAssociateProcess(clasifications: number[], consultaAvanzada: boolean = false, consultaAvanzadaId?: number): Promise<TramiteAsociar[]> {
    return new Promise((resolve, reject) => {
      const dataForm = {
        clasificaciones: clasifications,
        consulta_avanzada: consultaAvanzada,
        consulta: consultaAvanzadaId
      };
      this.http.post<TramiteAsociar[]>(this.api.get('documentAssociateProcess'), dataForm).subscribe(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta de las actas unicas del ministerio (AUCTIFF)
   *
   * @param {number} idConsecutive
   * @returns {Promise<ActaAUCTIFF[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getActasAUCTIFF(idConsecutive: number): Promise<ActaAUCTIFF[]> {
    return new Promise((resolve, reject) => {
      let params = '';
      if (idConsecutive) {
        params = '?consecutivo=' + String(idConsecutive);
      }
      this.http
        .get<ActaAUCTIFF[]>(Const.ROUTES_SYSTEM_INTEGRATIONS.cita.urlActasMinisterio + params).subscribe(
          resp => {
            resolve(resp);
          },
          err => {
            reject(err);
          }
        );
    });
  }


  /**
   * Consulta de las actas unicas del ministerio (AUCTIFF) desde cinco
   *
   * @param {number} idConsecutive
   * @returns {Promise<ActaAUCTIFF[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getActasAUCTIFFCinco(idConsecutive: number): Promise<ActaAUCTIFFCinco[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<ActaAUCTIFFCinco[]>(this.api.get('consecutiveAct', [idConsecutive])).subscribe(
          resp => {
            resolve(resp);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   *Obtiene la data para la tabla cuando el selector es de tipo Trámites
   *
   * @param {number[]} tramites
   * @param {string[]} estructura
   * @return {*}  {Promise<any[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getSelectorUtils(tramites: number[], estructura: string[], filtro_tramite: string[], dinamico: boolean = false, selector_dinamico: any = null,
    id_tramite: any = null, filters: any[], offset?: any,
    limit?: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      let dataForm: any = {
        tramites: tramites,
        estructura: estructura,
      };
      if (dinamico) {
        dataForm["dinamico"] = dinamico;
        dataForm["consulta_dinamica"] = selector_dinamico;
      } else {
        dataForm["filtro_tramite"] = filtro_tramite;
        dataForm["id_tramite"] = id_tramite;
      }
      if (offset != undefined && offset != null) {
        dataForm['offset'] = offset;
      }
      if (limit) {
        dataForm['limit'] = limit;
      }
      if (filters) {
        dataForm['filtros_columnas'] = filters;
      }


      this.http.post<any[]>(this.api.get('selectorUtils'), dataForm).subscribe(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        }
      );
    });
  }
  /*
   *Obtiene los tipos documentales asociados
   *
   * @param {number} idControl
   * @return {*}  {Observable<any[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getTypeDocumentaryControl(idControl: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>(this.api.get('control_documentary', [idControl])).subscribe(
        typeDocumentary => {
          resolve(typeDocumentary);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   *Obtiene el tipo documental seleccionado para el trámite
   *Lo setea en el control
   * @param {number} idTask
   * @return {*}  {Promise<any[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getExistingTypeDocumentaryControl(idTask: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>(this.api.get('existing_control_documentary', [idTask])).subscribe(
        typeDocumentary => {
          this.typeDocumentary
          resolve(typeDocumentary);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  getTableData(idTask: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<any[]>(this.api.get('dynamicFormInstance', [idTask])).subscribe(
          form => {
            resolve(form);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
            reject(err);
          }
        );
    });
  }

  getTask(idTask: number): Promise<Tarea> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<Tarea>(this.api.get('getInformationTask', [idTask])).subscribe(
          task => {
            resolve(task);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
            reject(err);
          }
        );
    });
  }

  /**
   *Obtiene el resultado de la consulta de campo solicitada
   *
   * @param {number} idTask
   * @param {string} searchName
   * @return {*}  {Promise<any>}
   * @memberof RefactorDynamicFormDataService
   */
  getSearchField(idTask: number, searchName: string): Promise<any> {
    const dataForm = {
      id_tarea: idTask,
      consulta: searchName
    };
    return new Promise((resolve, reject) => {
      this.http.post<any>(this.api.get('fieldSearch'), dataForm).subscribe(
        search => {
          resolve(search);
        },
        err => {
          reject(null);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/refactor-dynamic-form/shared/refactor-dynamic-form-data.service.ts